import { jsx as _jsx } from "react/jsx-runtime";

function SvgShow() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.927 11.844a1.9 1.9 0 01.058.156 1.9 1.9 0 01-.058.156c-.086.21-.235.494-.46.836-.452.684-1.137 1.489-2.01 2.256C16.687 16.806 14.388 18 12 18c-2.386 0-4.685-1.194-6.458-2.752-.872-.767-1.557-1.572-2.008-2.256a5.146 5.146 0 01-.461-.836A1.915 1.915 0 013.015 12c.012-.036.03-.088.058-.156.086-.21.235-.494.46-.836.452-.684 1.137-1.489 2.01-2.256C7.314 7.194 9.612 6 12 6c2.386 0 4.686 1.194 6.458 2.752.872.767 1.557 1.572 2.008 2.256.226.342.375.626.461.836zM23 12c0 2-4.925 8-11 8S1 14 1 12s4.925-8 11-8 11 6 11 8zm-9 0a2 2 0 11-4 0 2 2 0 014 0zm2 0a4 4 0 11-8 0 4 4 0 018 0z"
    }, void 0)
  }), void 0);
}

export default SvgShow;